import { render, staticRenderFns } from "./ActionLists.vue?vue&type=template&id=2475336c"
import script from "./ActionLists.vue?vue&type=script&lang=ts"
export * from "./ActionLists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports